module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-1.833bee78.png";